import React from 'react';

const PublicOffers = () => {
  return <div>PublicOffers</div>;
};

export default PublicOffers;
